import React, { useEffect } from "react";
import "./css/NewMyCources.css";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";

const NewMyCources = () => {
  const dispatch = useDispatch();
  const locationv = useLocation();

  const get_product_list = useSelector((state) =>
    state?.allapi?.user_product_search ? state?.allapi?.user_product_search : {}
  );

  const listdata = get_product_list?.docs ? get_product_list?.docs : [];

  console.log(listdata);

  const searchParams = new URLSearchParams(locationv.search);
  const search = searchParams.get("search");
  const location = searchParams.get("location");
  const page = searchParams.get("page");

  const pageno = page ? page : 1;
  useEffect(() => {
    // searchProduct

    if (search) {
      if (location) {
        dispatch(
          allapiAction.getDeducateListuserSide({
            page: pageno,
            id: search,
            location,
          })
        );
      } else {
        dispatch(
          allapiAction.getDeducateListuserSide({ page: pageno, id: search })
        );
      }
    } else {
      if (location) {
        dispatch(
          allapiAction.getDeducateListuserSide({ page: pageno, location })
        );
      } else {
        dispatch(allapiAction.getDeducateListuserSide({ page: pageno }));
      }
    }
    // dispatch(allapiAction.getfiltercategory({}));
    return () => {};
  }, [locationv.search]);
  return (
    <div className="container d-flex flex-column p-2">
      <div className=" fw-bold p-2 m-2" style={{color:"#ffd700"}}>My Courses</div>
      <div className="container-fluid p-2 mb-3">
        <div className="row">
          {listdata &&
            listdata.map((data, i) => {
              console.log(data);
              return (
                <div className="col-6 mt-2">
                  <Link
                    to={"/cources/" + data?.slug}
                    className="my-cources-card-link"
                  >
                    <div className="bg-dark w-100 h-100 text-light my-cources-card">
                      <div className="text-center my-cources-card-body">
                        <img
                          src={URL?.API_BASE_URL + data?.image}
                          alt={data?.name}
                          className="w-100 mb-3 my-cources-card-img"
                        />
                        <p className="my-cources-card-title" style={{color:"#ffd700"}}>{data?.name}</p>
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          {/* <div className="col-6 mt-2">
            <Link to={"/cources"} className="my-cources-card-link">
              <div className="bg-dark w-100 h-100 text-light my-cources-card">
                <div className="text-center my-cources-card-body">
                  <img
                    src=""
                    alt=""
                    className="w-100 mb-3 my-cources-card-img"
                  />
                  <p className="my-cources-card-title">Spoken English</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-6 mt-2">
            <Link to={"/cources"} className="my-cources-card-link">
              <div className="bg-dark w-100 h-100 text-light my-cources-card">
                <div className="text-center my-cources-card-body">
                  <img
                    src=""
                    alt=""
                    className="w-100 mb-3 my-cources-card-img"
                  />
                  <p className="my-cources-card-title">Web Development</p>
                </div>
              </div>
            </Link>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default NewMyCources;
